import { Row, Switch } from 'antd'
import styled from 'styled-components'

export const RuleSwitchRow = styled(Row)`
  align-items: center;
  margin-bottom: 12px;
`

export const RuleSwitch = styled(Switch)`
  &.ant-switch {
    margin-right: 12px;
  }
`
